<template>
  <a-layout id="components-layout-top" class="layout">
    <a-layout-header>
      <div style="float:left">
        <div class="logo">
          <template v-if="!xinyou">
            <img
              v-if="$store.getters.id == 5303"
              src="../assets/images/fudan_edu.png"
              style="vertical-align: middle;width:170px"
            />
            <img
              v-else
              src="../assets/images/logo-full.png"
              style="vertical-align: middle;width:170px"
            />
          </template>
          <img
            v-else-if="xinyou"
            src="../assets/images/xinyou-2.png"
            style="vertical-align: middle;width:170px"
          />
        </div>
        <a-menu mode="horizontal" theme="dark" :style="{ lineHeight: '64px' }">
          <template v-for="item in list">
            <a-menu-item :key="item.name">
              <router-link tag="li" :to="item.target">
                <!-- <img class="list-icon" :src="item.image"> -->
                {{ item.name }}
              </router-link>
            </a-menu-item>
          </template>
          <!-- <template v-for="item in lists" v-if="$store.getters.orgid == 18">
                    <a-menu-item :key="item.name">
                        <router-link tag="li" :to="item.target">
                            {{item.name}}
                        </router-link>
                    </a-menu-item>
          </template>-->
        </a-menu>
      </div>
      <div class="antd-right">
        <a-dropdown>
          <a v-if="!isZdy">
            <span class="head-name">{{ nickname }}</span>
            <a-avatar :src="imgUrl" />
          </a>
          <a v-if="isZdy">
            <span class="head-name">{{ personList.fullName }}</span>
            <a-avatar :src="imgUrl" />
          </a>
          <a-menu
            slot="overlay"
            v-if="isZdy"
            style="margin-top:20px;width:260px;text-align:center;"
          >
            <a-menu-item>
              <div class="perTop">
                <a-row type="flex" justify="space-around" align="middle">
                  <a-col :span="11" style="margin-right:-15px;">
                    <img style="width:120px;" :src="previewImage" alt />
                  </a-col>
                  <a-col :span="11">
                    <div>
                      <p>{{ personList.fullName }}</p>
                      <p class="twoLine">{{ personList.orgName }}</p>
                      <p>{{ personList.titleName }}</p>
                    </div>
                  </a-col>
                </a-row>
              </div>
              <div class="perBottom">
                <a @click="toSetting" style="margin-right:30px;">
                  <a-icon type="user" style="padding-right:10px;" />个人设置
                </a>
                <a @click="logout">
                  <a-icon type="logout" style="padding-right:10px;" />退出登录
                </a>
              </div>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </a-layout-header>
  </a-layout>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  data () {
    return {
      xinyou: false,
      selectKey: [],
      list: [
        // {
        //   name: '首页概览',
        //   target: '/homeReport',
        //   image: '@assets/images/mage_1.png',
        // },
        // {
        //   name: '年级报告',
        //   target: '/gradeReport',
        //   image: '../assets/images/mage_1.png',
        // },
        // {
        //   name: '学科报告',
        //   target: '/subjectReport',
        //   image: './static/img/22.png',
        // },
      ],
      lists: [
        {
          name: "首页概览",
          target: "/homeReport",
          image: "@assets/images/mage_1.png",
        },
        {
          name: "年级报告",
          target: "/gradeReport",
          image: "../assets/images/mage_1.png",
        },
        {
          name: "学科报告",
          target: "/subjectReport",
          image: "./static/img/22.png",
        },
        {
          name: "问卷调查",
          target: "/questionnaire",
          image: "./static/img/23.png",
        },
      ],
      personList: {},
      imgUrl: "",
      previewImage: "",
      isZdy: true,
      nickname: "",
    }
  },
  computed: {
    ...mapGetters(["permission_routes"]),
  },
  methods: {
    getImg () {
      this.$http
        .get(
          "v1/learnonly/personInfo/getQRcode",
          { params: { userid: this.$store.getters.id } },
          { responseType: "arraybuffer" }
        )
        .then((res) => {
          if (res != undefined) {
            this.previewImage = res.data
          }
        })
    },
    getUserInfo () {
      this.$http
        .get("v1/learnonly/personInfo/getPersonInfo", {
          params: { userid: this.$store.getters.id },
        })
        .then((res) => {
          this.personList = res.data
          this.imgUrl = res.data.avatar
        })
    },
    toSetting () {
      this.$router.push({
        path: "/setting",
      })
    },
    logout () {
      this.$store.dispatch("logout").then(() => {
        location.reload()
        this.$router.push({ path: "/login" })
        if (localStorage.getItem("handList")) {
          localStorage.removeItem("handList")
        }
      })
    },
  },
  mounted () {
    this.xinyou = window.location.href.includes("beikezu")
    this.nickname = sessionStorage.getItem("nickName")
    sessionStorage.getItem("isZdy") == null
      ? (this.isZdy = true)
      : (this.isZdy = false)

    sessionStorage.getItem("isTianli") == null
      ? (this.isTianli = true)
      : (this.isTianli = false)


    this.selectKey = [this.$route.name]
    const router = this.$store.getters.permission_routes
    router.map((item) => {
      if (item.children)
        item.children.map((children) => {
          if (children.name === this.$route.name && item.children.length === 1)
            this.selectKey = [item.name]
        })
    })
    this.getUserInfo()
    this.getImg()
  },
}
</script>

<style scoped>
#components-layout-top .logo {
  float: left;
  margin-right: 20px;
}
.ant-menu.ant-menu-horizontal .ant-menu-item-selected {
  background-color: transparent !important;
}
.ant-layout-header {
  background: #001529;
  padding: 0 15px;
  height: 64px;
  line-height: 64px;
  position: fixed;
  z-index: 999;
  width: 100%;
}
.antd-right {
  float: right;
  height: 100%;
  overflow: hidden;
  padding: 0;
  cursor: pointer;
}
.perTop {
  text-align: left;
}
.perTop p {
  margin: 0 0 10px 10px;
}
.perTop .twoLine {
  width: 90%;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.head-manage {
  display: inline-block;
  padding: 0 8px;
  margin-right: 15px;
  font-size: 14px;
  border-radius: 4px;
  height: 32px;
  line-height: 32px;
  color: #1890ff;
  /* border: 1px solid #1890ff; */
}
.head-name {
  color: rgba(255, 255, 255);
  padding-right: 10px;
}
.anticon svg {
  font-size: 16px;
}
.ant-dropdown-menu-item {
  padding: 0;
  line-height: 18px;
}
.ant-dropdown-menu-item:hover,
.ant-dropdown-menu-submenu-title:hover {
  background-color: #fff;
}
.perBottom {
  border-top: 2px dotted #eee;
  margin-top: 5px;
  padding: 10px 0 5px;
}
.perBottom a {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}
.perBottom a:hover {
  color: rgba(0, 0, 0, 0.65);
}
.ant-menu-submenu-title .anticon + span {
  font-size: 16px;
}
.ant-menu-item > a {
  font-size: 16px;
}
</style>
